module.exports = [
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-schneider-electric-2e03fb7a44.svg",
		"quote": "The Auth0 platform makes it easier for our developers and engineers to swiftly implement something ordinarily complicated. We’ve saved time, money, manpower (and a headache or two) when it comes to federated identity management.",
		"author": "Stephen Berard",
		"autorTitle": "Senior Global Software Architect"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-safari-books-faa4e77f69.svg",
		"quote": "Setting up our application to integrate with one partner [Auth0] and then having that partner act as a service hub for dozens of identity systems helps simplify work for our core development teams, while allowing our customer base to grow exponentially.",
		"author": "Cris Concepcion",
		"autorTitle": "Engineering Manager at Safari Books Online"
	},
	{
		"logo": "https://cdn.auth0.com/website/assets/pages/about/img/logos/logo-bluetooth-extended-534164cd16.svg",
		"quote": "Implementing the Auth0 identity solution took a single digit number of days versus the estimated months to build a solution in-house.",
		"author": "Jeremy Syme",
		"autorTitle": "Director of System Engineering at Bluetooth"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/data/quotes.json
// module id = 1355
// module chunks = 0